import React from 'react';
import { Link } from 'react-router';

import './Home.css';
import PublicShell from './PublicShell';

export default function Home() {
    return (
        <PublicShell>
            <div className="landing">
                <section className="landing__hero" aria-labelledby="landing-title">
                    <p className="landing__eyebrow">Closed alpha · Work in progress</p>
                    <h1 id="landing-title">Progress Lands</h1>
                    <h2>Make progress. Even when the wasteland has other plans.</h2>
                    <p className="landing__lede">
                        Progress Lands is still in closed alpha. Pre-register for development
                        news and future access, or log in if you are already testing the wasteland.
                    </p>

                    <div className="landing__release-note" aria-label="Release status">
                        <strong>We don’t have a release date yet—but it won’t be forever.</strong>
                        <span>And “forever” is a long time. Roughly 14 years, apparently.</span>
                        <span>
                            One thing we can promise: PC players won’t have to wait for a second
                            release date.
                        </span>
                    </div>

                    <div className="landing__actions">
                        <Link to="/login" className="landing__button landing__button--primary">
                            Alpha tester login
                        </Link>
                        <Link to="/register" className="landing__button landing__button--secondary">
                            Pre-register
                        </Link>
                    </div>

                    <ul className="landing__signals" aria-label="Game highlights">
                        <li>Idle progress</li>
                        <li>Map-first exploration</li>
                        <li>Build your operative</li>
                    </ul>
                </section>

                <aside className="landing__dispatch" aria-labelledby="dispatch-title">
                    <div className="landing__dispatch-topline">
                        <span>Amnesia Cove · Day one, probably</span>
                    </div>
                    <h2 id="dispatch-title">Fuck. My head.</h2>
                    <p>
                        I wake up with sand in my teeth and a hangover big enough to claim
                        citizenship. Either last night got ambitious, or somebody tried to
                        open my skull with a tire iron.
                    </p>
                    <p>
                        No people. No answers. Just gutted houses, rusted cars, and a gull
                        watching me like I owe it money. Something growls beyond the ruins.
                        Great. At least breakfast knows where I am.
                    </p>
                </aside>
            </div>
        </PublicShell>
    );
}
